import { render } from "./StepHeader.vue?vue&type=template&id=acf3e3aa&scoped=true"
import script from "./StepHeader.vue?vue&type=script&lang=js"
export * from "./StepHeader.vue?vue&type=script&lang=js"

import "./StepHeader.vue?vue&type=style&index=0&id=acf3e3aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf3e3aa"]])

export default __exports__